import { render, staticRenderFns } from "./SectionPlayers.vue?vue&type=template&id=4a2f5312&scoped=true&"
import script from "./SectionPlayers.vue?vue&type=script&lang=js&"
export * from "./SectionPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f5312",
  null
  
)

export default component.exports